import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useMemo } from 'react';
import * as classnames from 'classnames';
import { styled, Table, TableBody, TableCell, TableContainer, TableRow, } from '@mui/material';
import { Capability } from 'console/device/device-capability';
import { LegacyDevice } from 'console/device/device';
import { PowerSource } from 'console/device/device_ts';
import { prettyFloat } from 'webui/utils/number';
import { CardTableCell } from '../style/style-card';
const BatteryCell = styled(TableCell)({
    border: '0px',
    fontWeight: 100,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    color: '#444444',
});
export const PowerCard = React.memo(function PowerCard(props) {
    const { r_device } = props;
    const { voltage, power_source } = r_device;
    const has_lithium_battery = LegacyDevice.has_capability(r_device.capabilities, Capability.has_lithium_battery);
    const _power_source = useMemo(() => {
        return power_source != null
            ? power_source
            : has_lithium_battery && voltage != null && voltage < 7
                ? PowerSource.battery
                : PowerSource.main;
    }, [power_source, has_lithium_battery, voltage]);
    const ztc_absent_voltage = LegacyDevice.has_capability(r_device?.capabilities, Capability.has_lithium_ztc) &&
        voltage != null &&
        voltage < 7;
    const has_battery = power_source === PowerSource.battery;
    if (!LegacyDevice.has_capability(r_device?.capabilities, Capability.has_voltage_sensor)) {
        return null;
    }
    return (_jsxs(TableContainer, { className: "ui-falarm-main-view-power ui-card", children: [_jsx("div", { className: classnames('ui-card-icon', 'ui-icon-zta-power', has_battery ? 'battery' : 'ac') }), _jsx("h1", { children: "\u041F\u0438\u0442\u0430\u043D\u0438\u0435" }), _jsx(Table, { children: _jsxs(TableBody, { children: [(has_lithium_battery || r_device.power_source != null) && (_jsxs(TableRow, { children: [_jsx(CardTableCell, { component: "th", children: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A" }), _jsx(BatteryCell, { className: classnames('ui-state-tab-power-source', {
                                        battery: has_battery,
                                    }), style: {
                                        borderBottom: 0,
                                    }, children: {
                                        [PowerSource.main]: 'сеть',
                                        [PowerSource.usb]: 'USB',
                                        [PowerSource.battery]: 'аккумулятор',
                                    }[_power_source] })] })), _jsxs(TableRow, { className: classnames({
                                hidden: has_lithium_battery && voltage != null && voltage < 7,
                                warning: LegacyDevice.has_capability(r_device.capabilities, Capability.has_voltage_12v_low_level) &&
                                    voltage != null &&
                                    voltage < 12,
                            }), children: [_jsx(CardTableCell, { component: "th", children: "\u041D\u0430\u043F\u0440\u044F\u0436\u0435\u043D\u0438\u0435" }), _jsx(CardTableCell, { children: voltage != null
                                        ? ztc_absent_voltage
                                            ? 'отсутствует'
                                            : `${prettyFloat(voltage, 1)} В`
                                        : 'неизвестно' })] })] }) })] }));
});
